module.exports = __webpack_public_path__ + "media/images/start_footer-263dcb175276316be2d45c7b319950f8.webp";